import BN from "bn.js";
import { BNIsh, utils } from "@malloc-protocol/sdk";
import { NonSpecificConstruction } from "@malloc-protocol/sdk";
import { PublicKey } from "@solana/web3.js";
import { useEffect, useState } from "react";
import { NodeInfoProps, UpdateSourceFn } from "../../interfaces";
import { getAllRaydiumPools } from "../../utils/raydium";
import { LIGHT_1 } from "../colors";
import TokenAccountChooser from "../tokens/TokenAccountChooser";
import TokenLine from "../tokens/TokenLine";

const SourceNodeInfo = (props: {
  updateSource: UpdateSourceFn;
  inputMints: NonSpecificConstruction["source"]["mints"];
}) => {
  const [includedMints, setIncludedMints] = useState<string[] | undefined>(
    undefined
  );

  return (
    <>
      {props.inputMints !== undefined &&
      Object.keys(props.inputMints).length !== 0 ? (
        Object.keys(props.inputMints).map((m) => (
          <div
            style={{
              display: "grid",
              gap: "1rem",
              alignItems: "center",
              gridTemplateColumns: "150px 1fr 30px",
            }}
          >
            <TokenLine
              mint={m}
              amount={props.inputMints![m].toString()}
              updateFn={props.updateSource}
              inputMints={props.inputMints}
            />
            {/* <InputField
              value={
                props.inputMints![m].toString()
                // utils.tokens.toReadableNumber(new BN(props.inputMints![m]), tok.decimals)
              }
              size="small"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                props.inputMints[m] =
                  event.target.value === "" ? "0" : event.target.value;
                props.updateSource(props.inputMints);
              }}
              style={{
                color: LIGHT_1,
              }}
            /> */}
            {Object.keys(props.inputMints).length > 1 && (
              <button
                className="controls2"
                onClick={() => {
                  delete props.inputMints[m];
                  props.updateSource(props.inputMints);
                }}
              >
                x
              </button>
            )}
          </div>
        ))
      ) : (
        <>Unset</>
      )}
      {/* TODO:: Have a way to add and delete input mints */}
      <br />

      <TokenAccountChooser
        buttonText={"add mint"}
        includedMints={includedMints}
        onSelect={(token) => {
          const newMintAmount = "100";
          props.inputMints[token.address] = newMintAmount;
          props.updateSource(props.inputMints);
        }}
      />
      <br />
    </>
  );
};

export default SourceNodeInfo;
